export enum InvestigationMinutesStatus {
	AfterAnswers = "AFTER_ANSWERS",
	AfterSession = "AFTER_SESSION",
	Drafting = "DRAFTING",
	AwaitingAttestation = "AWAITING_ATTESTATION",
	Attested = "ATTESTED",
	SignedRequired = "SIGNED_REQUIRED",
	Uploaded = "UPLOADED",
	NoneCancelled = "NONE_CANCELLED",
}
